module.exports = __webpack_public_path__ + "img/download_transparent.b3ce3ca7.svg";